<template>
  <div>
    <v-container fluid>

      <div class="main">

        <v-row v-if="isLoading2">
          <v-col v-for="item in 4" :key="item" cols="12" lg="3">
            <v-card class="rounded-lg shadow">
              <v-card-text>
                <v-skeleton-loader type="list-item-avatar-three-line"></v-skeleton-loader>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>

        <v-row v-else>
          <v-col cols="12" lg="3">
            <v-card class="rounded-lg shadow">
              <v-card-text class="py-5">
                <v-row align="center" justify="center">
                  <v-col cols="3">
                    <v-avatar color="info" size="45">
                      <v-icon color="white">mdi-credit-card-multiple-outline</v-icon>
                    </v-avatar>
                  </v-col>
                  <v-col cols="9">
                    <div class="font-weight-black title pb-1 grey--text text--darken-3">
                      {{ statistics.total_created }}
                    </div>
                    Total de cartes créées
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </v-col>

          <v-col cols="12" lg="3">
            <v-card class="rounded-lg shadow">
              <v-card-text class="py-5">
                <v-row align="center" justify="center">
                  <v-col cols="3">
                    <v-avatar color="success" size="45">
                      <v-icon color="white">mdi-truck-check</v-icon>
                    </v-avatar>
                  </v-col>
                  <v-col cols="9">
                    <div class="font-weight-black title pb-1 grey--text text--darken-3">
                      {{ statistics.total_delivered }}
                    </div>
                    Cartes livrées
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </v-col>

          <v-col cols="12" lg="3">
            <v-card class="rounded-lg shadow">
              <v-card-text class="py-5">
                <v-row align="center" justify="center">
                  <v-col cols="3">
                    <v-avatar color="warning" size="45">
                      <v-icon color="white">mdi-credit-card-check-outline</v-icon>
                    </v-avatar>
                  </v-col>
                  <v-col cols="9">
                    <div class="font-weight-black title pb-1 grey--text text--darken-3">
                      {{ statistics.total_used }}
                    </div>
                    Cartes utilisées
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </v-col>

          <v-col cols="12" lg="3">
            <v-card class="rounded-lg shadow">
              <v-card-text class="py-5">
                <v-row align="center" justify="center">
                  <v-col cols="3">
                    <v-avatar color="purple" size="45">
                      <v-icon color="white">mdi-cash-multiple</v-icon>
                    </v-avatar>
                  </v-col>
                  <v-col cols="9">
                    <div class="font-weight-black title pb-1 grey--text text--darken-3">
                      {{ CurrencyFormatting(statistics.total_value) }} pts
                    </div>
                    Valeur totale rachetée
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>

        <v-row>
          <v-col>
            <v-tabs background-color="transparent" v-model="tab">
              <v-tab>
                <v-icon left>mdi-package-variant</v-icon>
                Lots
              </v-tab>
              <v-tab>
                <v-icon left>mdi-card-multiple-outline</v-icon>
                Gestion des cartes
              </v-tab>
              <v-tab>
                <v-icon left>mdi-truck-delivery</v-icon>
                Gestion des colis
              </v-tab>
            </v-tabs>
          </v-col>
        </v-row>


        <v-row v-if="tab === 0">
          <v-col cols="12">
            <v-card class="rounded-lg shadow">
              <v-overlay :value="overlay" absolute color="white" opacity="0.5">
                <v-progress-circular
                    color="primary"
                    indeterminate
                    size="50"
                ></v-progress-circular>
              </v-overlay>

              <v-card-title>

                <div>
                  <v-text-field
                      v-model="keyword"
                      append-icon="mdi-magnify"
                      @keydown.enter="getData"
                      hint="Appuyez sur ↵ Entrée pour rechercher"
                      clearable
                      @click:clear="[keyword=null,getData()]"
                      dense
                      filled
                      persistent-hint
                      placeholder="Recherche..."
                      rounded
                  ></v-text-field>
                </div>

                <v-spacer/>

                <v-btn color="grey"
                       text
                       @click="[getData(),getStatistics()]">
                  <v-icon left>mdi-refresh</v-icon>
                  Mettre à jour
                </v-btn>

                <v-btn color="grey"
                       text
                >
                  <v-icon left>mdi-filter-outline</v-icon>
                  Filtrer
                </v-btn>

                <v-btn class="rounded-lg"
                       color="gifty"
                       @click="openDialog"
                       dark
                       depressed
                >
                  <v-icon left>mdi-plus</v-icon>
                  lot
                </v-btn>

              </v-card-title>

              <v-divider/>

              <v-card-text v-if="isLoading">
                <v-skeleton-loader type="table"/>
              </v-card-text>

              <div v-else>
                <v-card-text>
                  <v-simple-table class="table-border rounded-lg" v-if="batchs.length">
                    <template v-slot:default>
                      <thead>
                      <tr>
                        <th>Désignation</th>
                        <th>Créer par</th>
                        <th>Date d'expiration</th>
                        <th>Créer le</th>
                        <th>Statut</th>
                        <th>Actions</th>
                      </tr>
                      </thead>
                      <tbody>
                      <tr v-for="(item ,index) in batchs" :key="index">

                        <td>
                          {{ item.note }}
                        </td>

                        <td>
                          {{ item.created_by.name }}
                        </td>


                        <td class="font-weight-medium">
                          {{ item.expiry_date }}
                        </td>

                        <td class="font-weight-medium">
                          {{ item.created_at }}
                        </td>

                        <td>
                          <v-menu offset-y>
                            <template v-slot:activator="{ on, attrs }">
                              <v-btn v-bind="attrs"
                                     :loading="loadingStatus[item.id]"
                                     depressed
                                     v-on="on"
                                     small
                                     dark
                                     :color="statusColor(item.status)"
                                     class="text-uppercase">
                                {{ item.status }}
                                <v-icon right>mdi-chevron-down</v-icon>
                              </v-btn>
                            </template>
                            <v-list>
                              <v-list-item @click="updateCampaignStatus('created',item.id,index)">
                                <v-list-item-title>
                                  <v-icon left small :color="statusColor('created')">mdi-circle</v-icon>Created
                                </v-list-item-title>
                              </v-list-item>
                              <v-list-item @click="updateCampaignStatus('printed',item.id,index)">
                                <v-list-item-title>
                                  <v-icon left small :color="statusColor('printed')">mdi-circle</v-icon> Printed
                                </v-list-item-title>
                              </v-list-item>
                            </v-list>
                          </v-menu>
                        </td>

                        <td>
                          <div class="d-flex align-center">
                            <v-btn icon color="gifty" @click="remove(item.id)">
                              <v-icon>mdi-delete-outline</v-icon>
                            </v-btn>

                            <v-btn text color="gifty" class="ml-2 v-btn--active"
                                   :loading="loadingPrint[item.id]"
                                   @click="handlePrint(item.id)">
                              <v-icon left>mdi-printer</v-icon>
                              Imprimer
                            </v-btn>

                            <v-btn text color="gifty" class="ml-2 v-btn--active"
                                   @click="$refs.cardsDialogRef.open(item)">
                              <v-icon left>mdi-credit-card-multiple-outline</v-icon>
                              {{ item.d_r_c_cards_count }} Carte(s)
                              <v-icon right>mdi-arrow-right</v-icon>
                            </v-btn>
                          </div>
                        </td>


                      </tr>
                      </tbody>
                    </template>
                  </v-simple-table>

                  <div v-else>
                    <NoResults @reload="getData"/>
                  </div>

                </v-card-text>
                <v-divider/>

                <v-card-actions>

                  <div :style="{width: '120px'}">
                    <v-select v-model="perPage"
                              :items="[10,20,30,50,100]"
                              dense
                              hide-details
                              label="Ligne par page"
                              outlined></v-select>
                  </div>

                  <v-spacer/>


                  <span class="text--darken-2 grey--text">
                      {{ pageStart }}-{{ pageEnd }} de {{ total }}
                  </span>
                  <v-pagination v-model="pagination.current"
                                :length="pagination.total"
                                circle
                                total-visible="8"
                                @input="getData"></v-pagination>

                </v-card-actions>

              </div>
            </v-card>
          </v-col>
        </v-row>

        <v-row v-if="tab === 1">
          <v-col cols="12">
            <CardsList/>
          </v-col>
        </v-row>

        <v-row v-if="tab === 2">
          <v-col cols="12">
            <ParcelsList/>
          </v-col>
        </v-row>

      </div>

      <v-dialog v-model="dialog" width="600" persistent scrollable>
        <v-card :loading="btnLoading" :disabled="btnLoading">
          <v-card-title>
            Créer un nouveau lot de cartes
            <v-spacer/>
            <v-icon @click="dialog = false">mdi-close</v-icon>
          </v-card-title>
          <v-divider/>
          <v-card-text class="pa-8">

            <v-text-field
                outlined
                label="Désignation *"
                dense
                :error-messages="errors.note"
                v-model="form.note"
            ></v-text-field>

            <v-text-field
                outlined
                label="Date d'expiration *"
                dense
                type="date"
                :error-messages="errors.expiry_date"
                v-model="form.expiry_date"
            ></v-text-field>


            <v-simple-table class="table-border rounded-lg">
              <template v-slot:default>
                <thead>
                <tr>
                  <th>Montant</th>
                  <th>Quantité</th>
                  <th>Actions</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="(item, i) in form.cards" :key="i">
                  <td>
                    <v-text-field
                        v-model="item.amount"
                        dense
                        hide-details="auto"
                        placeholder="Montant"
                        :error-messages="errors[`cards.${i}.amount`] || []"
                    />
                  </td>
                  <td>
                    <v-text-field
                        v-model="item.quantity"
                        dense
                        hide-details="auto"
                        placeholder="Quantité"
                        :error-messages="errors[`cards.${i}.quantity`] || []"
                    />
                  </td>
                  <td>
                    <div class="d-flex align-center">
                      <v-btn :disabled="form.cards.length === 1"
                             icon
                             color="red"
                             @click="deleteCard(i)"
                      >
                        <v-icon>mdi-close</v-icon>
                      </v-btn>

                      <v-btn v-if="i === form.cards.length - 1"
                             icon
                             color="gifty"
                             @click="addCard"
                      >
                        <v-icon>mdi-plus-circle</v-icon>
                      </v-btn>
                    </div>
                  </td>
                </tr>
                </tbody>
              </template>
            </v-simple-table>


          </v-card-text>
          <v-divider/>
          <v-card-actions>
            <v-spacer/>
            <v-btn color="gifty" dark depressed @click="saveData" :loading="btnLoading">
              <v-icon left>mdi-content-save</v-icon>
              Enregistrer
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

    </v-container>

    <CardsDialog ref="cardsDialogRef"/>

  </div>
</template>

<script>
import {HTTP} from "@/http-common";
import NoResults from "@/components/NoResults";
import CardsDialog from "./components/CardsDialog";
import CardsList from "./components/CardsList";
import ParcelsList from "./components/ParcelsList";

export default {
  components: {NoResults, CardsDialog,CardsList,ParcelsList},
  data() {
    return {
      id: '',
      tab: 'tab1',
      keyword: '',
      dialog: false,
      btnLoading: false,
      overlay: false,
      isLoading2: false,
      statistics: {},
      isLoading: false,
      errors: {},
      loadingStatus: {},
      loadingPrint: {},
      form: {},
      batchs: [],
      total: 0,
      perPage: 10,
      pagination: {
        current: 1,
        total: 0
      },
    };
  },
  methods: {
    statusColor(status) {
      if (status === "created"){
        return "info lighten-2"
      }
      if (status === "printed"){
        return "purple lighten-2"
      }
    },
    deleteCard(index) {
      this.form.cards.splice(index, 1)
    },
    addCard() {
      this.form.cards.push({amount: null, quantity: null})
    },
    openDialog() {
      this.dialog = true
      this.errors = {}
      const today = new Date();
      today.setFullYear(today.getFullYear() + 1);
      this.form = {
        expiry_date: today.toISOString().split("T")[0],
        cards: [
          {amount: null, quantity: null},
        ]
      }
    },
    getData() {
      this.isLoading = true
      HTTP.get('/v1/refill-card-delivery?page=' + this.pagination.current, {
        params: {
          perPage: this.perPage,
          keyword: this.keyword
        }
      }).then(res => {

        this.pagination.current = res.data.data.current_page;
        this.pagination.total = res.data.data.last_page;
        this.total = res.data.data.total;

        this.batchs = res.data.data.data

        this.isLoading = false
      }).catch(err => {
        this.isLoading = false
        console.log(err)
      })
    },
    getStatistics() {
      this.isLoading2 = true
      HTTP.get('/v1/refill-card-delivery/statistics').then(res => {
        this.statistics = res.data.data
        this.isLoading2 = false
      }).catch(err => {
        this.isLoading2 = false
        console.log(err)
      })
    },
    remove(id) {
      this.id = id;
      this.$confirm_dialog = true;
    },
    deleteItem() {
      this.overlay = true;
      HTTP.post("/v1/refill-card-delivery/delete", {
        id: this.id,
      }).then(() => {
        this.overlay = false;
        let i = this.batchs.findIndex((el) => el.id === this.id);
        this.$delete(this.batchs, i);
        this.id = null;
        this.$successMessage = "Cet élément a été supprimé avec succès.";
      }).catch((err) => {
        this.overlay = false;
        console.log(err);
      });
    },
    handlePrint(id) {
      this.$set(this.loadingPrint, id, false)
      this.loadingPrint[id] = true
      HTTP.get(`/v1/refill-card-delivery/print?id=${id}`, {responseType: 'blob'})
          .then(res => {
            const blob = new Blob([res.data], {type: 'application/pdf'});
            const link = document.createElement('a');
            link.href = URL.createObjectURL(blob);
            link.download = 'refill-cards.pdf';
            link.click();
            URL.revokeObjectURL(link.href);
          })
          .catch(err => {
            this.$errorMessage = "Server Error!";
            console.log(err);
          }).finally(() => {
        this.loadingPrint[id] = false
      })
    },
    saveData() {
      this.errors = {}
      this.btnLoading = true;
      HTTP.post("/v1/refill-card-delivery/store", this.form).then(() => {
        this.btnLoading = false;
        this.dialog = false;
        this.getData();
        this.$successMessage = "Cet élément a été ajouté avec succès.";
      }).catch((err) => {
        this.btnLoading = false;
        this.errors = err.response?.data?.errors || {};
        console.log(err);
      });
    },
    updateCampaignStatus(status, id, index) {
      this.$set(this.loadingStatus, id, false)
      this.loadingStatus[id] = true
      HTTP.post("/v1/refill-card-delivery/" + id + "/update-status", {
        status
      }).then(() => {
        this.loadingStatus[id] = false
        this.batchs[index].status = status
        this.$successMessage = "Cet élément a été modifié avec succès.";
      }).catch((err) => {
        this.loadingStatus[id] = false
        console.log(err);
      });
    },
  },
  created() {
    this.getData();
    this.getStatistics();
  },
  computed: {
    pageStart() {
      if (this.total === 0) return 0
      return (this.pagination.current - 1) * this.perPage + 1
    },
    pageEnd() {
      let end = this.pagination.current * this.perPage
      return end > this.total ? this.total : end
    }
  },
  watch: {
    $is_confirm: function (el) {
      if (el) {
        this.deleteItem();
        this.$is_confirm = false;
      }
    },
    perPage() {
      this.pagination.current = 1
      this.getData();
    },
  }
};
</script>

<style scoped></style>
